module.exports = __webpack_public_path__ + "static/media/fondo-00.c1788571.jpg";